import { render, staticRenderFns } from "./Type2_Weekly.vue?vue&type=template&id=5eb59da2&"
import script from "./Type2_Weekly.vue?vue&type=script&lang=js&"
export * from "./Type2_Weekly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports